import React from "react";
import {
  Datagrid,
  List,
  TextField,
  TopToolbar,
  useLocaleState,
} from "react-admin";

const LayoutList = () => {
  const [locale] = useLocaleState();

  return (
    <List pagination={false} filters={[]} actions={<TopToolbar></TopToolbar>}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField label="layout.slogan" source={`slogan.${locale}`} />
      </Datagrid>
    </List>
  );
};

export default LayoutList;
